module.exports = __webpack_public_path__ + "static/media/sonic.d64de00d.gif";